import { observable, action } from 'mobx';
import { INavigationItem } from '@estee/elc-navigation-header';
import {
  DELIVERY,
  PAYMENT,
} from '../../routes';
import { NAVIGATION_ITEM_IDS } from '../../constants/Constants';

export const MOBILE_CUTOFF = '960px';

const defaultNavigationItemsState: INavigationItem[] = [{
  href: `#/${DELIVERY.ROUTE}`,
  id: NAVIGATION_ITEM_IDS.deliveryId,
  isActive: false,
}, {
  href: `#/${PAYMENT.ROUTE}`,
  id: NAVIGATION_ITEM_IDS.paymentId,
  isActive: false,
}];
class UIState {
  @observable isMobile = this.isMobileCheck;

  @observable navigationItems: INavigationItem[] = [...defaultNavigationItemsState];

  resizeHandler(): void {
    if (this.isMobile !== this.isMobileCheck) {
      this.updateIsMobile(this.isMobileCheck);
    }
  }

  get isMobileCheck(): boolean {
    return window.matchMedia(`(max-width: ${MOBILE_CUTOFF})`).matches;
  }

  @action
  updateIsMobile(isMobile: boolean): void {
    this.isMobile = isMobile;
  }

  @action
  updateItemActiveState(id: string, isActive: boolean): void {
    const index = this.navigationItems.findIndex(item => item.id === id);
    if (index >= 0) {
      this.navigationItems[index].isActive = isActive;
    }
  }
}

export default UIState;
